import { useState, useEffect, useRef } from 'react';

function useHover() {
  const [isHover, setIsHover] = useState(false);
  const elementRef = useRef(null);
  const observerRef = useRef(null);

  useEffect(() => {
    const handlePointerEnter = () => setIsHover(true);
    const handlePointerLeave = () => setIsHover(false);

    // Função para lidar com a mudança de visibilidade do botão
    const handleIntersection = entries => {
      const entry = entries[0];
      if (!entry.isIntersecting) {
        setIsHover(false);
      }
    };

    const element = elementRef.current;

    if (element) {
      element.addEventListener('pointerenter', handlePointerEnter);
      element.addEventListener('pointerleave', handlePointerLeave);

      const observer = new IntersectionObserver(handleIntersection, {
        root: null,
        rootMargin: '0px',
        threshold: [0]
      });

      observer.observe(element);
      observerRef.current = observer;
    }

    return () => {
      if (element) {
        element.removeEventListener('pointerenter', handlePointerEnter);
        element.removeEventListener('pointerleave', handlePointerLeave);
        if (observerRef.current) {
          observerRef.current.unobserve(element);
        }
      }
    };
  }, []);

  return [isHover, elementRef];
}

export default useHover;
